import TlSetDriverVehicleinfoModal from './tl-set-driver-vehicleinfo-modal.vue'
export default TlSetDriverVehicleinfoModal
